<template>
    <div class="confirmar-nuevo-destinatario"> 
        <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"/>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Nuevo destinatario
            </b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label style="color: #ff5855">¿Están correctos los datos?</label> 
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Nombre de Referencia</label>
                        <base-input v-model="model.referenceName"/>
                    </div>
                </div>

                <div v-for="(item,index) in model.contact.Owners" v-bind:key="index">
                    <div class="row form-group">
                        <div class="col-md-12">
                            <label>Nombre</label>
                            <base-input v-model="item.Name" readonly/>
                        </div>
                    </div>
                     <div class="row form-group">
                        <div class="col-md-12">
                            <label v-text="item.IDType"/>
                            <base-input v-model="item.CuitCuil" readonly/>
                        </div>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12">
                        <label>CBU/CVU</label>
                        <base-input v-model="model.contact.CBUCVU" readonly/>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Alias</label>
                        <base-input v-model="model.contact.Label" readonly></base-input>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Banco</label>
                        <base-input v-model="model.contact.BankName" readonly></base-input>
                    </div>
                </div>
                
                <div class="row form-group" >
                    <div class="col-md-12 text-center">
                        <save-button text="Agregar Contacto" @click="preAddContact()"/>
                    </div>
                </div> 

                <div class="row form-group" >
                    <div class="col-md-12 text-center">
                        <b-button class="btn btn-danger" @click="goBack()">Volver</b-button>
                    </div>
                </div>
            </b-card-body>
        </b-card> 
        <pin-validation ref="pin-validation"
        :showModal.sync="showModalPinValidation"
        v-on:validPin="onValidPin"
        v-on:loadUsePaymentPin="onLoadUsePaymentPin">
        </pin-validation>
    </div>
</template>

<script>
import notificationHelpers from '@/helpers/notificationHelpers';
import axiosHelpers from "@/helpers/axiosHelpers";
import PinValidation from '@/views/Pin/PinValidation';


export default {
    components: {
    "pin-validation": PinValidation
    },
    name: "ConfirmarNuevoDestinatario",
    props: {
        propContact: null,
        propHash: ''
    },
    data() {
        return {
            model: {
                contact: this.propContact,
                hash: this.propHash,
                referenceName: '',
            },
            usePaymentPin: false,
            showModalPinValidation: false,
            itemContact: null
        };
    },
    methods: {
        addContact() {
            let context = this;

            if (context.model.referenceName == undefined || context.model.referenceName == '') {
                notificationHelpers.showWarning(
                    "Advertencia!",
                    "Debe ingresar un nombre de referencia para el contacto",
                    context
                );
                
                return;
            }

            context.model.contact.ContactName = context.model.referenceName;

            this.$validator.validate().then(valid => {
                if (valid) {
                    axiosHelpers.axiosPost(
                        "TransferenceContact/AddContactTransference",
                        {
                            Contact: context.model.contact,
                            Hash: context.model.hash
                        },
                        this,
                        function(data) {
                            if(data.Alerts.length == 0) {
                                notificationHelpers.showSuccess(
                                    'Exito', 
                                    'Destinatario agregado correctamente.', 
                                    context
                                );

                                context.$router.push('AgendaDestinatarios');
                            }
                        }
                    );
                } else {
                    notificationHelpers.showWarning(
                        "Advertencia!",
                        "Verifique los campos",
                        context
                    );
                }
            });
        },
        preAddContact(){
            let context = this;
            if (context.model.referenceName == undefined || context.model.referenceName == '') {
                notificationHelpers.showWarning(
                    "Advertencia!",
                    "Debe ingresar un nombre de referencia para el contacto",
                    context
                );
                return;
            }            
            context.pinValidate();
        },
        onValidPin(val) {
            let context = this;
            if(val) {
                context.addContact();
            }
        },
        onLoadUsePaymentPin(val) {
           let context = this;
           context.usePaymentPin = val;
        },
        pinValidate() {
            let context = this;
            if(context.usePaymentPin) {
                context.showModalPinValidation = true;
            } else {
                context.addContact();
            }
        },       
        goBack() {
            this.$router.push('NuevoDestinatario');
        }
    }
}
</script>